import axios from "axios";
import env from "../data/env";

const Token = axios.create({
  baseURL: env.API_URL,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const clearAuthStorage = () => {
  localStorage.removeItem("verified");
  localStorage.removeItem("remember_me");
  localStorage.removeItem("user");
};

Token.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response, config = {} } = error;

    if (response?.status === 401) {
      const requestUrl = config.url || "";
      const isLoginRequest = requestUrl.includes("auth/login");
      const hasAuthMarker = Boolean(localStorage.getItem("verified"));
      const isLoginPage = ["/", "/login"].includes(window.location.pathname);

      // A guest request (including /auth/login with invalid credentials) is
      // not an expired session. Leave the error for the calling component.
      // Only redirect when an existing authenticated session has expired.
      if (!isLoginRequest && hasAuthMarker && !isLoginPage) {
        clearAuthStorage();
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  }
);

export default Token;
